<template>
  <div>
    <div class="static-page-wrapper" v-html="pageContent"></div>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
export default {
  name: "HtmlComponent",
  components: {},
  props: ["dataResults"],
  data() {
    return {
      pageContent: "",
      errorCase: `
      <div class='pTB20 pl20 pr20 tc pa w100' style='top:50%;left:50%;transform:translate(-50%, -50%)'> 
          <i aria-hidden="true" class="jfi-alert-sign color-error fs-36"></i>
          <p class="fs-14 tc mt16">
            Something went wrong, please try again!
          </p>
      </div>`,
    };
  },
  mounted() {
    if (
      this.dataResults != "null" &&
      typeof this.dataResults != "undefined" &&
      typeof this.dataResults
    ) {
      this.pageContent = JSON.parse(this.dataResults)?.[0]?.page_content;

      if (!this.pageContent) {
        this.pageContent = this.errorCase;
      }
    } else {
      this.pageContent = this.errorCase;
    }

    this.hidePageLoader();
  },
  methods: {
    hidePageLoader() {
      const loader = document.getElementById("pageLoader");
      if (loader) {
        loader.style.display = "none";
      }
    },
  },
  computed: {},
};
</script>

